import { render, staticRenderFns } from "./orderFlow.vue?vue&type=template&id=7bc08cfc&scoped=true&"
import script from "./orderFlow.vue?vue&type=script&lang=js&"
export * from "./orderFlow.vue?vue&type=script&lang=js&"
import style0 from "./orderFlow.vue?vue&type=style&index=0&id=7bc08cfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc08cfc",
  null
  
)

export default component.exports